export default __webpack_public_path__ + "static/media/ethereum-icon.a993ece2.svg";